var Social = (function () {

    var unknownMethodError = function ( method ) {
        return Social.error( 'social.unknownMethod', 'Unknown method "' + method + '" called' )
    };

    var Social = function ( name, methods ) {
        Social.instance = this;
        var social = this;
        if ( methods ) {
            this._name = name;
            this._methods = methods;
        } else {
            this._name = "social";
            this._methods = name;
        }
        this._server = new JSServer( this._name, function () {
            social._callFunction.apply( social, arguments );
        } );
        for ( var method in this._methods ) {
            (function ( method ) {
                social[ method ] = function ( data, fn ) {
                    social._callFunction( method, data, fn );
                }
            })( method );
        }
    };

    Social.error = function ( name, description ) {
        return {
            error : true,
            name : name || 'social.unnamedError',
            description : description || ''
        };
    };

    Social.success = function ( data ) {
        return {
            success : true,
            data : data
        };
    };

    Social.profile = function ( id, name, photo, gender, url, age, country, city, online ) {
        return new SocialProfile( id, name, photo, gender, url, age, country, city, online );
    };

    Social.profile.GENDER_MALE = "male";
    Social.profile.GENDER_FEMALE = "female";

    var SocialProfile = function ( id, name, photo, gender, url, age, country, city, online ) {
        this.id = id;
        this.name = name;
        this.photo = photo;
        this.gender = gender;
        this.url = url;
        this.age = age;
        this.country = country;
        this.city = city;
        this.online = online;
    };

    Social.share = function ( sender, target, type, code, title, description, action, image, extra ) {
        return new SocialShare( sender, target, type, code, title, description, action, image, extra );
    };

    Social.share.fromObject = function ( obj ) {
        return new SocialShare( obj.sender, obj.target, obj.type, obj.code, obj.title, obj.description, obj.action, obj.image, obj.extra );
    };

    Social.share.TYPE_REQUEST = "REQUEST";
    Social.share.TYPE_WALL_POST = "WALL_POST";
    Social.share.TYPE_NOTIFICATION = "NOTIFICATION";
    Social.share.TYPE_FACEBOOK_STORY = "FACEBOOK_STORY";

    var SocialShare = function ( sender, target, type, code, title, description, action, image, extra ) {
        this.sender = sender;
        this.target = target;
        this.type = type;
        this.code = code;
        this.title = title;
        this.description = description;
        this.action = action;
        this.image = image;
        this.extra = extra;
    };

    var SocialOffer = function ( code, realMoneyPrice, title, description, image, extra ) {
        this.code = code;
        this.realMoneyPrice = realMoneyPrice;
        this.title = title;
        this.description = description;
        this.image = image;
        this.extra = extra;
    };

    Social.offer = function ( code, realMoneyPrice, title, description, image, extra ) {
        new SocialOffer( code, realMoneyPrice, title, description, image, extra );
    };

    Social.offer.fromObject = function ( obj ) {
        return new SocialOffer( obj.code, obj.realMoneyPrice, obj.title, obj.description, obj.image, obj.extra );
    };

    function SocialCallback(obj, method, fn) {
        this._obj = obj;
        this._method = method;
        this._fn = fn;
    }

    SocialCallback.prototype = {
        success : function () {
            Logger.log( 'Social.callback.success', this._method, arguments );
            if ( this._fn ) {
                this._fn.call(this._obj, Social.success.apply(Social, arguments));
            }
        },
        error : function () {
            Logger.log( 'Social.callback.error', this._method, arguments );
            if ( this._fn ) {
                this._fn.call(this._obj, Social.error.apply(Social, arguments));
            }
        }
    };

    Social.prototype = {
        _callFunction : function ( method, data, fn ) {
            Logger.log( "Social._callFunction", method, data );
            if ( method in this._methods ) {
                this._methods[method].call( this, data, new SocialCallback( this, method, fn ) );
            } else {
                Logger.warn( "Social._callFunction", "unknown method", method );
                if ( fn ) {
                    fn.call(this, unknownMethodError(method));
                }
            }
        }
    };

    return Social;

})();
